import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import { ResponsiveImage } from '../ResponsiveImage';
import {
  StyledSplitPanels,
  Wrapper,
  ContentPanel,
  ContentPanelInner,
  ImagePanel,
  ImagePadding,
  ImageContainer,
} from './styles.js';

export const SplitPanels = ({
  image,
  alignImage = 'right',
  backgroundColor,
  fillColor,
  content,
  // by default, content (icons, header, body copy, buttons, etc.) is vertically centered inside a color block
  // if you wish to change this, pass centered={false} (ie: SplitPanels in CheckoutConfirmationContainer)
  centered = true,
}) => {
  const renderImage = () => (
    <>
      <ImagePadding />
      <ImageContainer>
        <ResponsiveImage
          {...omit(image, ['width', 'height'])}
          layout="fill"
          objectFit="cover"
        />
      </ImageContainer>
    </>
  );

  return (
    <StyledSplitPanels fillColor={fillColor}>
      <Wrapper>
        <ContentPanel backgroundColor={backgroundColor} centered={centered}>
          <ContentPanelInner centered={centered}>{content}</ContentPanelInner>
        </ContentPanel>

        <ImagePanel alignImage={alignImage}>{renderImage()}</ImagePanel>
      </Wrapper>
    </StyledSplitPanels>
  );
};

SplitPanels.displayName = 'SplitPanels';

SplitPanels.propTypes = {
  image: PropTypes.object.isRequired,
  icon: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  }),
  heading: PropTypes.string,
  body: PropTypes.node,
  content: PropTypes.node,
  alignImage: PropTypes.oneOf(['left', 'right']),
  backgroundColor: PropTypes.string,
  fillColor: PropTypes.string,
  socialMediaIcons: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  centered: PropTypes.bool,
};
